export default __webpack_public_path__ + "static/service-right-main-pic-602fe3ef2a065ca3d4210fc0085b79bd.png";